export const blocksConfig: Record<
  string,
  {
    headerText: string;
    isPromocodeBlockShowing: boolean;
    isLongTableShowing: boolean;
  }
> = {
  default: {
    headerText: 'Check in with your body',
    isPromocodeBlockShowing: true,
    isLongTableShowing: true,
  },
  gift: {
    headerText: 'Gift self-care to those you care about',
    isPromocodeBlockShowing: true,
    isLongTableShowing: false,
  },
  'promo-special': {
    headerText: 'Your special offer&#10;on Welltory Premium',
    isPromocodeBlockShowing: false,
    isLongTableShowing: false,
  },
  chatgpts: {
    headerText: 'Analyze your data with ChatGPTs',
    isPromocodeBlockShowing: false,
    isLongTableShowing: false,
  },
};
